<template>
<div class="page extra-hours">
  <h1>Extra uren</h1>
</div>
</template>

<script>
export default {
name: "ExtraHours"
}
</script>
